<template>
  <div class="contract-audit">
    <div class="search-wrap">
      <el-input class="search-val" v-model.trim="contractName" placeholder="请输入合同名称" maxLength="30" clearable></el-input>
      <el-input class="search-val" v-model.trim="applyUserName" placeholder="请输入发起人" maxLength="10" clearable></el-input>
      <el-input class="search-val" v-model.trim="customerName" placeholder="请输入客户名称" maxLength="10" clearable></el-input>
      <el-select class="search-val" v-model="auditState" clearable placeholder="请选择审核状态" v-show="activeTab !== 'waiting'">
        <el-option v-for="(val, key) in auditStateObj" :key="key" :label="val" :value="key"></el-option>
      </el-select>
      <el-date-picker
        v-model="contractDate"
        class="date-val"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd HH:mm:ss"
        clearable
        :default-time="['00:00:00', '23:59:59']"
      >
      </el-date-picker>
      <div class="operate-btns">
        <el-button type="primary" @click="getTableList" icon="el-icon-search">查询</el-button>
        <el-button plain @click="reset">重置</el-button>
      </div>
    </div>
    <div class="list-table">
      <el-tabs class="tab-content" v-model="activeTab" @tab-click="tabClick">
        <el-tab-pane label="待我审批的" name="waiting" lazy>
          <new-table ref="payTableRef" :data="tableData" :columns="columns" :pages="pages"></new-table>
        </el-tab-pane>
        <el-tab-pane label="我已审批的" name="approved" lazy>
          <new-table ref="payTableRef" :data="tableData" :columns="viewColumns" :pages="pages"></new-table>
        </el-tab-pane>
        <el-tab-pane label="我发起的" name="initiator" lazy>
          <new-table ref="payTableRef" :data="tableData" :columns="viewColumns" :pages="pages"></new-table>
        </el-tab-pane>
        <el-tab-pane label="抄送我的" name="copyTo" lazy>
          <new-table ref="payTableRef" :data="tableData" :columns="viewColumns" :pages="pages"></new-table>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import { ContractApis } from "@/apis";
import NewTable from "@/components/new-table";
import { AuditState } from "@/utils/enum";
export default {
  name: "contract-audit",
  props: { contract: Object },
  data() {
    return {
      visible: false,
      tableData: [],
      auditStateObj: AuditState,
      contractName: "",
      applyUserName: "",
      customerName: "",
      auditState: "",
      contractDate: [],

      activeTab: "waiting",
      columns: [
        {
          label: "合同名称",
          render: (h, { row }) => (
            <el-button type="text" onClick={() => this.$router.push(`./contract-detail?id=${row.contractId}`)}>
              {row.contractName}
            </el-button>
          ),
        },
        { label: "合同编号", prop: "contractNo", minWidth: "150px" },
        { label: "客户名称", prop: "customerName" },
        { label: "合同金额", prop: "contractAmount" },
        { label: "申请人", prop: "creatorUserName" },
        { label: "备注", prop: "remark" },
        { label: "发起时间", prop: "opDate" },
        {
          label: "操作",
          width: "80px",
          render: (h, { row }) => (
            <auth-button size="mini" type="text" onClick={() => this.toAuditDetail(row)}>
              处理
            </auth-button>
          ),
        },
      ],
      viewColumns: [
        {
          label: "合同名称",
          render: (h, { row }) => (
            <el-button type="text" onClick={() => this.$router.push(`./contract-detail?id=${row.contractId}`)}>
              {row.contractName}
            </el-button>
          ),
        },
        { label: "合同编号", prop: "contractNo", minWidth: "150px" },
        {
          label: "客户名称",
          render: (h, { row }) => (
            <el-button type="text" onClick={() => this.$router.push(`./customer-detail?id=${row.customerId}`)}>
              {row.customerName}
            </el-button>
          ),
        },
        { label: "申请人", prop: "creatorUserName" },
        { label: "备注", prop: "remark" },
        { label: "操作时间", prop: "opDate" },
        { label: "状态", render: (h, { row }) => <audit-state-text state={row.state} /> },
        {
          label: "操作",
          width: "80px",
          render: (h, { row }) => (
            <auth-button size="mini" type="text" onClick={() => this.toAuditDetail(row)}>
              查看
            </auth-button>
          ),
        },
      ],
      pages: {
        props: {
          pageSize: 20,
          currentPage: 1,
          total: 0,
        },
        on: {
          currentChange: this.pageChange,
          sizeChange: this.sizeChange,
        },
      },
    };
  },
  mounted() {
    this.getTableList();
  },
  methods: {
    tabClick() {
      this.pages.props.currentPage = 1;
      this.pages.props.pageSize = 20;
      this.pages.props.total = 0;
      this.getTableList();
    },
    // 回款计划
    async getTableList() {
      this.tableData = [];
      const { currentPage, pageSize } = this.pages.props;
      const params = {
        applyUserName: this.applyUserName,
        customerName: this.customerName,
        contractName: this.contractName,
        auditState: this.auditState,
        startDt: (this.contractDate && this.contractDate[0]) || "",
        endDt: (this.contractDate && this.contractDate[1]) || "",
        pageIndex: currentPage,
        pageSize,
      };
      let res = {};
      switch (this.activeTab) {
        case "waiting":
          res = await ContractApis.getStayMyAuditList(params);
          break;
        case "approved":
          res = await ContractApis.getMyAuditedList(params);
          break;
        case "initiator":
          res = await ContractApis.getMyCreatedList(params);
          break;
        case "copyTo":
          res = await ContractApis.getCopyToMeList(params);
          break;
        default:
          break;
      }
      this.tableData = res.data;
      this.pages.props.total = res.dataCount;
    },
    reset() {
      this.applyUserName = "";
      this.customerName = "";
      this.contractName = "";
      this.auditState = "";
      this.contractDate = [];
      this.pages.props.currentPage = 1;
      this.getTableList();
    },
    toAuditDetail(row) {
      this.$router.push(`/approval-info?insId=${row.insID}&dataId=${row.contractId}&type=contract`);
    },
    pageChange(p) {
      this.pages.props.currentPage = p;
      this.getTableList();
    },
    sizeChange(size) {
      this.pages.props.pageSize = size;
      this.pageChange(1);
    },
  },
  components: { NewTable },
};
</script>
<style scoped lang="scss">
.contract-audit {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.search-wrap {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .search-val {
    width: 170px;
    margin-right: 10px;
    margin-bottom: 18px;
  }
  .date-val {
    width: 280px;
    margin-right: 24px;
    margin-bottom: 18px;
  }
  .operate-btns {
    flex: 1;
    margin-bottom: 18px;
    min-width: 245px;
  }
}
</style>
